import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
export const QuillWrapper = (param)=>{
    let { htmlContent , className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames(className),
        dangerouslySetInnerHTML: {
            __html: htmlContent
        }
    });
};
